<template>
  <v-card class="pa-3" max-width="600px">
    <div class="my-0 pa-0">
      <v-card-title class="d-flex justify-center my-2 pa-0">
        {{ title }}</v-card-title
      >

      <v-form @submit.prevent="saveSelections">
        <v-row class="d-flex justify-center pa-0 my-0">
          <v-col cols="4" md="4">
            <v-autocomplete
              v-model="selectedRoles"
              :items="getRoles"
              item-text="name"
              item-value="id"
              label="Selecciona Rol"
              outlined
              dense
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" md="4">
            <v-autocomplete
              v-model="selectedPermission"
              :items="permissions"
              item-text="name"
              item-value="id"
              label="Seleccionar Permiso"
              dense
              outlined
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="2" md="2">
            <v-btn type="submit" class="bt-acept"> Guardar </v-btn>
          </v-col>
        </v-row>
        <v-list>
          <template v-for="(item, index) in getPermissions">
            <v-list-item :key="index">
              <v-list-item-content>
                <div class="d-flex w-100">
                  <span class="flex-grow-1 text-start">{{ item.rolName }}</span>
                  <span class="flex-grow-1 text-start">{{
                    getPermissionName(item.rolPermission)
                  }}</span>
                </div>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="confirmDelete(item)">
                  <v-icon id="icon-delete">mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider
              v-if="index < getPermissions.length - 1"
              :key="'divider-' + index"
            ></v-divider>
          </template>
        </v-list>
        <div class="d-flex justify-center py-2 mx-2">
          <v-btn class="bt-exit" @click="cancel">{{
            $tc("editRegistrations.cancel")
          }}</v-btn>
        </div>
      </v-form>
    </div>
    <Snackbar
      :alert="showSnackbar"
      :textAlert="textSnackbar"
      :color="colorSnackbar"
    />
    <v-dialog v-model="dialog" max-width="350px">
      <v-card>
        <v-card-text class="text-center pt-2"
          >¿Esta seguro que desea eliminar este permiso?</v-card-text
        >
        <v-card-actions class="d-flex justify-space-between">
          <v-btn class="bt-acept" text @click="closeDialog">Cancelar</v-btn>
          <v-btn class="bt-exit" text @click="deleteItem">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import Snackbar from "../Complement/Snackbar.vue";
import TableWithSearch from "../Complement/TableWithSearch.vue";
import roles from "@/store/autorizaciones/roles";
import Vue from "vue";
import reports from "../../store/reportes/reports";
import "vuetify/dist/vuetify.min.css";
import { VSelect, VTextField, VAutocomplete } from "vuetify/lib";

Vue.component("v-autocomplete", VAutocomplete);
Vue.component("v-text-field", VTextField);
export default {
  components: {
    TableWithSearch,
    Snackbar,
  },
  props: {
    parameters: Array,
    data: Number,
  },
  data() {
    return {
      lala: [],
      items: {},
      valid: true,
      error: false,
      alertValidate: "",
      title: "Permisos",
      permissions: [
        { id: "P", name: "Propietario" },
        { id: "C", name: "Colaborador" },
        { id: "L", name: "Lector" },
      ],
      selectedRoles: null,
      selectedPermission: null,
      loading: false,
      showSnackbar: false,
      textSnackbar: "",
      colorSnackbar: "",
      dialog: false,
    };
  },
  mounted() {
    this.items = Vue.observable(this.parameters);
    roles.dispatch("getRoles").then(() => {
      this.isLoading = false;
    });
  },
  computed: {
    getRoles() {
      return roles.state.roles;
    },
    getPermissions() {
      return reports.state.permissions;
    },
  },

  methods: {
    getPermissionName(permissionId) {
      const permission = this.permissions.find(
        (perm) => perm.id === permissionId
      );
      return permission ? permission.name : "Unknown";
    },
    cancel() {
      this.$emit("cancel", false);
    },
    alert(text, color, alert) {
      this.showSnackbar = alert;
      this.textSnackbar = text;
      this.colorSnackbar = color;
      setTimeout(() => {
        this.showSnackbar = false;
      }, 3000);
    },
    confirmDelete(item) {
      this.itemToDelete = item;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      reports.commit("setDeleteItem", null);
    },
    saveSelections() {
      if (this.selectedRoles && this.selectedPermission) {
        const selectedRole = this.getRoles.find(
          (item) => item.id === this.selectedRoles
        );
        const rolName = selectedRole ? selectedRole.name : "Unknown";

        const payload = {
          reporteId: this.data,
          rolId: this.selectedRoles,
          rolPermiso: this.selectedPermission,
          rolName: rolName,
        };
    
        reports.commit("setNewPermission", payload);
        reports
          .dispatch("addPermission")
          .then(() => {
            this.alert(
              this.$tc("reports.savePermissionSucces"),
              "success",
              true
            );
          })
          .catch((e) => {
            const errorMessage =
              e.response && e.response.data && e.response.data.error
                ? e.response.data.error.statusCode === 403
                  ? this.$tc("reports.error403")
                  : e.response.data.error.message
                : "Error inesperado";

            this.alert(errorMessage, "error", true);
          });
      } else {
        this.alert(e.response.data.error.message, "error", true);
      }
    },
    deleteItem() {
      let data = { reporteId: this.data, rolId: this.itemToDelete.rolId };
      reports.commit("setDeleteItem", data);
      reports
        .dispatch("deletePermission")
        .then(() => {
          this.alert(
            this.$tc("reports.deletePermissionSucces"),
            "success",
            true
          );
          this.closeDialog();
        })
        .catch((error) => {
          this.alert(e.response.data.error.message, "error", true);
          this.closeDialog();
        });
    },
  },
};
</script>
<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.bt-exe {
  background-color: #39537a !important;
  color: white !important;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
}
.container-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
}

.card {
  max-width: 500px;
}

.card__form {
  max-height: 250px;
  overflow-y: scroll;
}
</style>
